import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("i", {
    class: _normalizeClass(["icon", `icon-${$props.name}`])
  }, null, 2 /* CLASS */))
}